import axios from './http'
import Axios from 'axios';
import base from './base';
import qs from 'qs';

const global = {
  getwxcs() {
    return axios.get(`${base.baseURL}/api-visa/center/anon/wxcs`)
  },
  getIndexData(params) {
    return axios.get(`${base.baseURL}/api-visa/home`, {
      params: params
    })
  },
  getCodeImgUrl(deviceId) {
    return `${base.baseURL}/api/validate/${deviceId}`
  },
  getSmsCode(mobile, params) {
    return axios.get(`${base.baseURL}/api-uaa/validata/smscode/${mobile}`, {
      params: params
    })
  },
  getEmailCode(params) {
    return axios.get(`${base.baseURL}/api-uaa/validata/emailcode`, {
      params: params
    })
  },
  getUnprocessedCount() {
    return axios.get(`${base.baseURL}/api-apply/unprocessed/count`)
  },
  getMsgList(params) {
    return axios.get(`${base.baseURL}/api-msg/message/list`, {
      params: params
    })
  },
  getAnnouncementList(params) {
    return axios.get(`${base.baseURL}/api-visa/announcement/list`, {
      params: params
    })
  },
  getUploadToken(params) {
    return axios.post(`${base.baseURL}/api/file/upload/token/common`, params)
  },
  getAddressList(params) {//常用地址
    return axios.get(`${base.baseURL}/api-address/address/list`, {
      params: params
    })
  },
  setDefaultAddress(params) {
    return axios.put(`${base.baseURL}/api-address/address/default`, '', {
      params: params
    })
  },
  deleteAddress(id) {
    return axios.delete(`${base.baseURL}/api-address/address/${id}`)
  },
  getPlaceList(params) {//省市区
    return axios.get(`${base.baseURL}/api/place/common/list`, {
      params: params
    })
  },
  saveAddress(params) {
    return axios.post(`${base.baseURL}/api-address/address`, params)
  },
  changeMobile(params) {
    return axios.put(`${base.baseURL}/api-uaa/mobile/modify`, params)
  },
  getEmbassyList(params) {
    return axios.get(`${base.baseURL}/api-visa/embassy/all`)
  },
  uploadFile2OOS(actionUrl, params) { //因为上传文件接口的返回数据格式和别的接口不一样，没走封装的asiox对象。
    return Axios.post(actionUrl, params, {
      headers: {
        'Content-Type': "multipart/form-data"
      }
    })
  },

  postFeedback(params) {
    return axios.post(`${base.baseURL}/api-user/feedback/user`, params)
  },
  getSysConfig(code) {
    return axios.get(`${base.baseURL}/api-content/config/find/${code}`)
  },
  sendMaterialToEmail(params) {
    return axios.post(`${base.baseURL}/api/order/invoice/record/mail/common`, params)
  },
  saveInvoice(params) {
    return axios.post(`${base.baseURL}/api/order/invoice/record`, params)
  },
  getAllVisaCenter() {
    return axios.get(`${base.baseURL}/api-visa/center/all`)
  },
  readAllMsg() {
    return axios.put(`${base.baseURL}/api-msg/message/read/all`)
  },
  getProductData(productId) {
    return axios.get(`${base.baseURL}/api/visa/product/${productId}/common`)
  },
  getInvoiceList(params) {
    return axios.get(`${base.baseURL}/api-order/invoice/title`, {
      params: params
    })
  },
  setDefaultInvoice(params) {
    return axios.put(`${base.baseURL}/api-order/invoice/title/default`, '', {
      params: params
    })
  },
  getInvoiceDetail(id) {
    return axios.get(`${base.baseURL}/api-order/invoice/title/${id}`)
  },
  deleteInvoice(id) {
    return axios.delete(`${base.baseURL}/api-order/invoice/title/${id}`)
  },
  changeEmail(params) {
    return axios.put(`${base.baseURL}/api-user/users/email`, params)
  },
  applyInvoice(params) {
    return axios.post(`${base.baseURL}/api-order/invoice/record/users`, params)
  },
  getApplyInvoiceDetail(id) {
    return axios.get(`${base.baseURL}/api-order/invoice/record/${id}`)
  }
}
const userAccount = {
  register(params) {
    return axios.post(`${base.baseURL}/api-uaa/signup/user`, params)
  },
  resetPsd(params) {
    return axios.put(`${base.baseURL}/api-uaa/password/reset`, params)
  },
  login() {
    return axios.post(`${base.baseURL}/api/account/anon/login`)
  },
  LoginOrNot() {
    return axios.get(`${base.baseURL}/api/account/status`)
  },
  orgLogin(params) {
    return axios.post(`${base.baseURL}/api/account/ta/login`, params)
  },
  changePsd(params) {
    return axios.put(`${base.baseURL}/api-user/users/password`, params)
  },
  getUserInfo() {
    return axios.get(`${base.baseURL}/api-user/users/current`)
  }
}
const visa = {
  getAddressSearch(params) {
    return axios.post(`${base.baseURL}/api/korea/address/search`, params)
  },
  // 生成申请表
  generateForm(id) {
    return axios.get(`${base.baseURL}/api/visa/apply/generate/${id}`)
  },
  // 获取已生成申请表
  getGenerateForm(id) {
    return axios.get(`${base.baseURL}/api/visa/apply/find/apply/${id}/from`)
  },
  // 发送申请表到邮箱
  sendingMailboxForm(params) {
    return axios.post(`${base.baseURL}/api/visa/apply/send/email`, params)
  },

  putIncorrectDetails(id, params) {
    return axios.put(`${base.baseURL}/api-apply/apply/${id}/incorrect/detail`, params)
  },
  putIncorrect(id, params) {
    return axios.put(`${base.baseURL}/api-apply/apply/${id}/incorrect`, params)
  },
  getIncorrect(id) {
    return axios.get(`${base.baseURL}/api-apply/apply/${id}/incorrect`)
  },
  getObjectInfo(id, params) {
    return axios.get(`${base.baseURL}/api/visa/object/${id}/common`, {
      params: params
    })
  },
  getObjectList(params) {
    return axios.get(`${base.baseURL}/api/visa/object/common/list`, {
      params: params
    })
  },
  getUnprocessedList() {
    return axios.get(`${base.baseURL}/api-apply/unprocessed/list`)
  },
  deleteUnprocessed(id) {
    return axios.delete(`${base.baseURL}/api-apply/unprocessed/${id}`)
  },
  getPermanentList() {
    return axios.get(`${base.baseURL}/api-visa/permanent/list`)
  },
  getVisaCenterBasic() {
    return axios.get(`${base.baseURL}/api/visa/center/all`)
  },
  getVisaCenterBasicInfo(id) {
    return axios.get(`${base.baseURL}/api/visa/center/common?code=${id}`)
  },
  getVisaCenter(params) {
    return axios.get(`${base.baseURL}/api-visa/center/index/permanent`, {
      params: params
    })
  },
  getVisaCenterDetail(centerId) {
    return axios.get(`${base.baseURL}/api/visa/center/${centerId}/common`)
  },
  getVisaTypeList(params) {
    return axios.get(`${base.baseURL}/api/visa/type/common/list`, {
      params: params
    })
  },
  getVisaProductList(params) {
    return axios.get(`${base.baseURL}/api/visa/product/common/list`, {
      params: params
    })
  },
  getVisaProductDetail(id) {
    return axios.get(`${base.baseURL}/api/visa/product/${id}/common`)
  },
  getOrderForm(id) {
    return axios.get(`${base.baseURL}/api-apply/apply/form/download?orderId=${id}`)
  },
  saveApply(params) {
    return axios.post(`${base.baseURL}/api/visa/apply/form/create`, params)
  },
  // 创建签证申请
  saveApplyUser(params) {
    return axios.post(`${base.baseURL}/api/visa/apply/submit/user`, params)
  },
  getApplyInfoType(params) {
    return axios.post(`${base.baseURL}/api/visa/apply/query`, params)
  },
  getApplyInfo(token) {
    return axios.get(`${base.baseURL}/api/visa/apply/query`, {params: {
      token: token
    }})
  },
  applyMobileLimit(params) {
    return axios.get(`${base.baseURL}/api-apply/apply/mobile/limit`, {
      params: params
    })
  },
  deleteApply(applyId) {
    return axios.delete(`${base.baseURL}/api-apply/apply?applyId=${applyId}`)
  },
  putVisaApply(params) {
    return axios.put(`${base.baseURL}/api-apply/apply`, params)
  },
  getVisaApplyDetail(applyId, orderId) {
    return axios.get(`${base.baseURL}/api/visa/apply/${applyId}/user`, {
      params: {
        orderId
      }
    })
  },
  getVisaApplyDetailById(id) {
    return axios.get(`${base.baseURL}/api/visa/apply/user/${id}`)
  },
  getApplyQrcode(applyId) {
    return axios.post(`${base.baseURL}/api-apply/apply/form/qrcode?applyId=${applyId}`)
  },
  getApplySignQrcode(applyId, orderId) {
    return axios.get(`${base.baseURL}/api/visa/apply/${applyId}/sign/qrcode?orderId=${orderId}`)
  },

  certificatePassport(params) {
    return axios.post(`${base.baseURL}/api/ocr/passport/common`, params)
  },
  certificateIdCardBack(params) {
    return axios.post(`${base.baseURL}/api-ocr/ocr/certificate/idcard/back`, params)
  },
  certificateIdCardFront(params) {
    return axios.post(`${base.baseURL}/api-ocr/ocr/certificate/idcard/front`, params)
  },
  // 识别银行卡
  certificateIdCardBankcard(params) {
    return axios.post(`${base.baseURL}/api/ocr/bankcard`, params)
  },
  visaComplete(params) {
    return axios.post(`${base.baseURL}/api-apply/apply/complete`, '', {
      params: params
    })
  },
  visaConfirm(params) {
    return axios.put(`${base.baseURL}/api/visa/apply/${params.applyId}/confirm?orderId=${params.orderId}`)
  },
  createForm(applyId) {
    return axios.get(`${base.baseURL}/api-apply/apply/form?applyId=${applyId}`)
  },
  getVisaSign(params) {
    return axios.get(`${base.baseURL}/api/visa/apply/${params.applyId}/sign`, {
      params
    })
  },
  getSignImg(params) {
    return axios.get(`${base.baseURL}/api-apply/apply/sign/create`, {
      params: params
    })
  },
  getReservation(params) {
    return axios.get(`${base.baseURL}/api-vois/reservation`, {
      params: params
    })
  }
}
const order = {
  getIncorrectHistory(applyId) {
    return axios.get(`${base.baseURL}/api-apply/apply/${applyId}/incorrect/history`)
  },
  startOrder(params) {
    return axios.post(`${base.baseURL}/api/visa/order`, params)
  },
  // 额外补退费记录
  getExtraPayment(id) {
    return axios.get(`${base.baseURL}/api-order/order/${id}/extra/payment`)
  },
  confirmOrder(params) {
    return axios.put(`${base.baseURL}/api/visa/order/${params.id}/confirm`, params)
  },
  getOrderList(params) {
    return axios.get(`${base.baseURL}/api-order/order/list`, {
      params: params
    })
  },
  getOrderDetail(orderId) {
    return axios.get(`${base.baseURL}/api/visa/order/${orderId}/user`)
  },
  deleteOrder(orderId) {
    return axios.delete(`${base.baseURL}/api-order/order/user/${orderId}`)
  },
  applyReservation(params) {
    return axios.post(`${base.baseURL}/api-vois/reservation/apply`, params)
  },
  deleteReservation(orderId) {
    return axios.delete(`${base.baseURL}/api-vois/reservation/apply?orderId=${orderId}`)
  },
  getExpressInfo(params) {
    return axios.get(`${base.baseURL}/api-express/express/route`, {
      params: params
    })
  },
  cancelOrder(orderId) {
    return axios.put(`${base.baseURL}/api-order/order/${orderId}/cancel`)
  }
}
const article = {
  getArticleTypeList(params) {
    return axios.get(`${base.baseURL}/api-content/article/type/anon/list`, {
      params: params
    })
  },
  getArticleList(params) {
    return axios.get(`${base.baseURL}/api-content/article/list`, {
      params: params
    })
  },
  getArticleDetail(articleId) {
    return axios.get(`${base.baseURL}/api-content/article/detail/${articleId}`)
  }
}
const pay = {
  // 其他支付 支付宝
  extraAliPay(params) {
    return axios.get(`${base.baseURL}/api-order/extra/pay/alipay`, {
      params: params
    })
  },
  // 其他支付 微信
  extraWxPay(params) {
    return axios.get(`${base.baseURL}/api-order/extra/pay/wechat/pc`, {
      params: params
    })
  },
  // 微信回调
  getExtraWxPayStatus(params) {
    return axios.get(`${base.baseURL}/api-order/extra/pay/wechat/status`, {
      params: params
    })
  },
  // 支付宝回调
  getExtraAliPayStatus(params) {
    return axios.get(`${base.baseURL}/api/pay/visa/order/alipay/status`, {
      params: params
    })
  },
  // 支付
  aliPay(params) {
    return axios.get(`${base.baseURL}/api/pay/visa/order/alipay/pc`, {
      params: params
    })
  },
  wxPay(params) {
    return axios.get(`${base.baseURL}/api/pay/visa/order/wx/pc`, {
      params: params
    })
  },
  getWxPayStatus(params) {
    return axios.get(`${base.baseURL}/api/pay/visa/order/wx/status`, {
      params: params
    })
  },
  getAliPayStatus(params) {
    return axios.get(`${base.baseURL}/api/pay/visa/order/alipay/status`, {
      params: params
    })
  },
}

const crypt = {
  getRSASecretKey() {
    return axios.get(`${base.baseURL}/api/crypto/rsa/public/key`)
  },
  RSAEncryptTest(data) {
    return axios.post(`${base.baseURL}/api/crypto/rsa/test/decrypt`, data)
  }
}


export default {
  global,
  userAccount,
  visa,
  order,
  article,
  pay,
  crypt
}



// WEBPACK FOOTER //
// ./src/request/api.js